export default __webpack_public_path__ + "static/media/webcam.2f5477c2.svg";